module.exports = __webpack_public_path__ + "static/img/banner2.acdd7e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner2.jpg
// module id = y5LZ
// module chunks = 12